import React from 'react';
import { inject } from 'mobx-react';
import SelectField from 'common/components/fields/SelectField';

const SelectComponent = inject('dataSelectStore')((props) => {
  const isSelectFieldDisabled = () => {
    const { optionsName, disableOnEmpty } = props;
    return (!props.dataSelectStore[optionsName] || props.dataSelectStore[optionsName].length === 0) && disableOnEmpty;
  };
  return <SelectField selectStore={props.dataSelectStore} isSelectFieldDisabled={isSelectFieldDisabled} {...props} />;
});

export default SelectComponent;



// WEBPACK FOOTER //
// ./src/containers/DataSelect/SelectComponent.jsx